import { DateInput, TextInput } from '@core/components/Inputs';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import SelectProduto from 'app/components/Select/SelectProduto';
import { useFormikContext } from 'formik';
import React from 'react';

const onlyNumberRegex = /^\d*$/;

const CompraBuscaAvancadaForm = () => {
  const formik = useFormikContext();
  const _errors = {};

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={6}>
        <TextInput
          id="compraId"
          name="compraId"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.compraId}
          maxLength={3}
          fullWidth
          variant="outlined"
          label="Identificador"
          pattern={onlyNumberRegex}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <DateInput
          fullWidth
          id="dataCompra"
          label="Data da compra"
          value={formik.values.dataCompra || null}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={!!_errors.dataCompra}
          helperText={_errors.dataCompra}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectFornecedor
          handleChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          fornecedor={formik.values?.fornecedor}
          error={_errors.fornecedor}
          touched={!!_errors.fornecedor}
          autoFocus
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCategoria
          id="categoria"
          label="Categoria"
          value={formik.values?.categoria}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={100}
          natureza="DESPESA"
          touched={!!_errors.categoria}
          error={_errors.categoria}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectProduto
          id="produto"
          name="produto"
          label="Nome do produto"
          onChange={formik.handleChange}
          value={formik.values?.produto}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              id="imobilizado"
              name="imobilizado"
              value={formik.values?.imobilizado}
              checked={formik.values?.imobilizado}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              size="small"
            />
          }
          label="Consumo próprio/Ativo imobilizado"
        />
      </Grid>
    </Grid>
  );
};

export default CompraBuscaAvancadaForm;
